import { useState } from "react";

const categories = [
  { id: "general", label: "Allgemein", icon: "ri-question-line" },
  { id: "legal", label: "Rechtliches", icon: "ri-scales-3-line" },
  { id: "payment", label: "Zahlung", icon: "ri-secure-payment-line" },
  { id: "prize", label: "Gewinne & Preise", icon: "ri-trophy-line" },
];

const faqs: { id: number; cat: string; q: string; a: string }[] = [
  // Allgemein
  {
    id: 1, cat: "general",
    q: "Ist die Lotterie in Deutschland wirklich legal?",
    a: "Ja, absolut. Unsere Immobilien-Verlosung wird in Übereinstimmung mit der geltenden deutschen Gesetzgebung für Glücksspiele organisiert. Der Veranstalter, die Dreamify gGmbH, verfügt über eine offizielle Lizenz der GGL (Gemeinsame Glücksspielbehörde der Länder) vom 28. Juni 2024. Diese Erlaubnis ist öffentlich im offiziellen GGL-Register einsehbar.",
  },
  {
    id: 2, cat: "general",
    q: "Wer kann teilnehmen?",
    a: "Teilnahmeberechtigt ist jede natürliche Person ab 18 Jahren mit Wohnsitz in Deutschland. Die Teilnahme von Minderjährigen ist strengstens untersagt. Zur Validierung des Gewinns kann vom Gewinner ein Identitätsnachweis verlangt werden.",
  },
  {
    id: 3, cat: "general",
    q: "Wie viele Ziehungen haben bisher stattgefunden?",
    a: "Seit unserem Start im Jahr 2022 haben wir 51 Ziehungen durchgeführt. Bei jeder Ziehung wurde ein Gewinner ermittelt und der Preis in aller Transparenz übergeben. Die Protokolle aller vergangenen Ziehungen sind auf Anfrage erhältlich.",
  },
  {
    id: 4, cat: "general",
    q: "Kann ich an mehreren Ziehungen gleichzeitig teilnehmen?",
    a: "Ja. Jede Ziehung ist unabhängig. Sie können Lose für die aktuelle Ziehung kaufen und sich, sobald eine neue Ziehung angekündigt wird, auch an dieser beteiligen. Ihre Lose gelten nur für die Ziehung, für die sie gekauft wurden.",
  },
  // Rechtliches
  {
    id: 5, cat: "legal",
    q: "Wie ist der rechtliche Rahmen dieser Ziehung?",
    a: "Veranstalter der Verlosung ist die Dreamify gGmbH, eine gemeinnützige Gesellschaft (gGmbH) nach deutschem Recht. Sie ist durch die GGL-Lizenz Nr. 2024-06-28 zur Durchführung berechtigt. Die Ziehung wird von Notar Dr. Hans-Peter Schmidt überwacht, der die Integrität und den Zufallscharakter der Ermittlung bescheinigt.",
  },
  {
    id: 6, cat: "legal",
    q: "Wie wird der Zufallscharakter der Ziehung zertifiziert?",
    a: "Die Gewinnnummer wird durch einen kryptografisch sicheren Zufallsalgorithmus (CSPRNG) generiert, der dem Standard ISO/IEC 18031 entspricht. Der Algorithmus wird jährlich von einem unabhängigen Institut geprüft. Das Ergebnis wird im Beisein des Notars protocolliert, der das offizielle Ziehungsprotokoll unterzeichnet.",
  },
  {
    id: 7, cat: "legal",
    q: "Was ist die GGL und warum ist sie wichtig?",
    a: "Die GGL (Gemeinsame Glücksspielbehörde der Länder) ist die im Jahr 2021 geschaffene gemeinsame Regulierungsbehörde der deutschen Bundesländer für Glücksspiele. Sie erteilt und kontrolliert Lizenzen für Lotterien und Online-Glücksspiele. Ihre Aufsicht garantiert, dass der Veranstalter hohe Standards beim Spielerschutz, der Transparenz und der Suchtprävention einhält.",
  },
  {
    id: 8, cat: "legal",
    q: "Sind Gewinne in Deutschland steuerpflichtig?",
    a: "In Deutschland sind Lotteriegewinne gemäß § 4 Nr. 9b UStG grundsätzlich von der Einkommensteuer befreit. Bitte beachten Sie jedoch, dass spätere Erträge aus dem Gewinn (z. B. Mieteinnahmen oder Zinsen) steuerpflichtig sein können. Wir empfehlen Ihnen, für Ihre individuelle Situation einen Steuerberater zu konsultieren. Der Veranstalter stellt eine offizielle Gewinnbestätigung für Ihre Unterlagen aus.",
  },
  {
    id: 9, cat: "legal",
    q: "Wie sieht die Spielerschutz-Politik aus?",
    a: "Gemäß den gesetzlichen Anforderungen bieten wir Instrumente für verantwortungsbewusstes Spielen an: temporärer oder permanenter Selbstausschluss, Ausgabenlimits und Bedenkzeiten vor dem Kauf. Unser Präventionsteam ist täglich erreichbar. Externe Hilfe finden Sie unter: bundesweit-gegen-gluecksspielsucht.de.",
  },
  // Zahlung
  {
    id: 10, cat: "payment",
    q: "Welche Zahlungsmittel werden akzeptiert?",
    a: "Wir akzeptieren: Visa, Mastercard, PayPal, SEPA-Überweisung, Klarna (Rechnungskauf), Apple Pay und Google Pay. Alle Zahlungen werden über PCI-DSS-zertifizierte Anbieter abgewickelt. Ihre Bankdaten werden niemals auf unseren Servern gespeichert.",
  },
  {
    id: 11, cat: "payment",
    q: "Kann ich eine Rückerstattung erhalten, wenn ich es mir anders überlege?",
    a: "Sobald die Lose ausgestellt und die Zahlung validiert wurde, sind Käufe gemäß den AGB verbindlich und endgültig. Falls jedoch eine Ziehung durch den Veranstalter aus irgendeinem Grund abgesagt werden sollte, werden alle gezahlten Beträge innerhalb von 5 Werktagen ohne Abzug zurückerstattet.",
  },
  {
    id: 12, cat: "payment",
    q: "Ist die Zahlung sicher?",
    a: "Ja. Alle Transaktionen nutzen das TLS 1.3 Protokoll (256-Bit-SSL-Verschlüsselung). Unsere Plattform ist nach PCI-DSS Level 1 zertifiziert, dem höchsten Sicherheitsstandard für die Verarbeitung von Kartenzahlungen. Ein Siegel des TÜV Saarland bestätigt die Sicherheit unserer Infrastruktur.",
  },
  // Gewinne
  {
    id: 13, cat: "prize",
    q: "Wie wird der Wert der Immobilie ermittelt?",
    a: "Jede Immobilie wird durch einen unabhängigen Notar oder Immobiliengutachter nach marktüblichen Kriterien (Fläche, Lage, Zustand, Ausstattung) bewertet. Die Bewertung erfolgt spätestens 3 Monate vor der Ziehung. Das Gutachten ist auf Anfrage erhältlich.",
  },
  {
    id: 14, cat: "prize",
    q: "Was passiert nach dem Gewinn?",
    a: "Der Gewinner wird innerhalb von 24 Stunden nach der Ziehung persönlich per Telefon und E-Mail kontaktiert. Eine vollständige rechtliche Begleitung für die Eigentumsübertragung wird sichergestellt: Notarauswahl, Unterzeichnung der Urkunde, Schlüsselübergabe. Alle Notarkosten werden vom Veranstalter übernommen.",
  },
  {
    id: 15, cat: "prize",
    q: "Kann ich die gewonnene Immobilie verkaufen oder vermieten?",
    a: "Absolut. Sobald die Immobilie auf Ihren Namen im Grundbuch eingetragen ist, können Sie frei darüber verfügen: selbst bewohnen, vermieten oder verkaufen. Es gibt keine Nutzungsbeschränkungen seitens des Veranstalters.",
  },
  {
    id: 16, cat: "prize",
    q: "Gibt es Trostpreise?",
    a: "Ja, bei jeder Ziehung werden zusätzlich mehrere Sachpreise vergeben: Gutscheine, Reisegutscheine oder Geldpreise (1.000 € bis 10.000 €). Diese Preise werden unter allen Teilnehmern verlost, die nicht den Hauptpreis gewonnen haben.",
  },
];

function FaqItem({ item }: { item: typeof faqs[0] }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`border rounded-2xl overflow-hidden transition-all duration-300 ${open ? "border-slate-300 bg-white" : "border-slate-100 bg-white hover:border-slate-200"}`}>
      <button
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span className={`font-semibold text-sm leading-snug transition-colors duration-200 ${open ? "text-slate-900" : "text-slate-700"}`}>
          {item.q}
        </span>
        <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${open ? "bg-slate-900 text-white rotate-45" : "bg-slate-100 text-slate-500"}`}>
          <i className="ri-add-line text-sm"></i>
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${open ? "max-h-96" : "max-h-0"}`}>
        <p className="text-slate-600 text-sm leading-relaxed px-6 pb-6">{item.a}</p>
      </div>
    </div>
  );
}

export default function LegalFaq() {
  const [activeCat, setActiveCat] = useState("general");
  const filtered = faqs.filter((f) => f.cat === activeCat);

  return (
    <section id="faq" className="py-24" style={{ background: "linear-gradient(180deg, #f8fafc 0%, #fff 100%)" }}>
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="uppercase text-primary text-xs font-bold tracking-widest">Häufig gestellte Fragen</span>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-slate-900 mt-2 mb-4">
            Alles, was Sie wissen müssen
          </h2>
          <p className="text-slate-500 max-w-lg mx-auto leading-relaxed">
            Vollständige Transparenz über den Ablauf, den rechtlichen Rahmen, Zahlungen und Gewinne.
          </p>
        </div>

        {/* Category tabs */}
        <div className="flex items-center justify-center gap-2 flex-wrap mb-10">
          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => setActiveCat(c.id)}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap transition-all duration-200 ${
                activeCat === c.id
                  ? "bg-slate-900 text-white shadow-md"
                  : "bg-white text-slate-500 border border-slate-200 hover:border-slate-300 hover:text-slate-700"
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${c.icon} text-sm`}></i>
              </span>
              {c.label}
            </button>
          ))}
        </div>

        {/* FAQ list */}
        <div className="space-y-3">
          {filtered.map((item) => (
            <FaqItem key={item.id} item={item} />
          ))}
        </div>

      </div>
    </section>
  );
}
